import { render, staticRenderFns } from "./template02.vue?vue&type=template&id=223787ac&scoped=true&"
import script from "./template02.vue?vue&type=script&lang=js&"
export * from "./template02.vue?vue&type=script&lang=js&"
import style0 from "./template02.vue?vue&type=style&index=0&id=223787ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223787ac",
  null
  
)

export default component.exports